export default {
  gallery: {
    active: 'Active galleries',
    inactive: 'Archived galleries',
    future: 'Upcoming galleries',
  },
};
